
export default function ProductCTA() {
  return (
    <section className="py-16 bg-gradient-to-r from-red-600 to-orange-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Ready to Enhance Your Fire Safety?
          </h2>
          <p className="text-xl text-red-100 mb-8 max-w-3xl mx-auto">
            Get expert consultation and customized foam fire extinguisher solutions for your facility
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <button className="bg-white text-red-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-phone-line mr-2"></i>
              Call +974 5554 4093
            </button>
            <button className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-red-600 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-mail-line mr-2"></i>
              Request Quote
            </button>
            <button className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-red-600 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-download-line mr-2"></i>
              Download Catalog
            </button>
          </div>

          {/* Contact Info */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="text-white">
              <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-phone-line text-xl"></i>
              </div>
              <h3 className="font-semibold mb-1">Phone Support</h3>
              <p className="text-red-100">+974 5554 4093</p>
            </div>

            <div className="text-white">
              <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="font-semibold mb-1">Email Support</h3>
              <p className="text-red-100">info@flameguardqa.com</p>
            </div>

            <div className="text-white">
              <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-time-line text-xl"></i>
              </div>
              <h3 className="font-semibold mb-1">Business Hours</h3>
              <p className="text-red-100">Sun-Thu: 8AM-6PM</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
